import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../auth/login/login.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient, public router: Router, private loginSvc: LoginService) {}

  getPerfil(): Observable<any> {
		return new Observable<any>(observer => {
			const accessToken = this.loginSvc.getAccessToken();

			const options = {
				headers: new HttpHeaders({
					'Authentication': 'Bearer ' + accessToken,
					'Content-Type': 'application/json; charset=utf-8'
				})
			}

			const body = {
				id: localStorage.getItem("idCliente")
			};

			const url = environment.API_URL + '/clientesolicitante/get-cliente-user';
			this.http.post(url, body, options).subscribe(
				(response: any) => {
					console.log("ws getPerfil", response);
					observer.next(response);
				},
				(err) => {
					console.log("error ws getPerfil", err);
					let msgError = "Se ha producido un error guardando los datos";

					observer.error(msgError);
				}
			);

			return {unsubscribe() {}};
		});
	}

  updatePerfil(datos: any, direccion:any): Observable<any> {
		return new Observable<any>(observer => {
			const accessToken = this.loginSvc.getAccessToken();

			const options = {
				headers: new HttpHeaders({
					'Authentication': 'Bearer ' + accessToken,
					'Content-Type': 'application/json; charset=utf-8'
				})
			}

			const body = {
				id: localStorage.getItem("idCliente"),
        nombre: datos.nombre,
        apellidos: datos.apellidos,
        pais: direccion.pais,
        provincia: direccion.provincia,
        poblacion: direccion.poblacion,
        direccion: direccion.direccion,
        codigoPostal: direccion.codigoPostal,
        phone: direccion.phone
			};

			const url = environment.API_URL + '/clientesolicitante/update-cliente-user';
			this.http.post(url, body, options).subscribe(
				(response: any) => {
					console.log("ws updatePerfil", response);
					observer.next(response);
				},
				(err) => {
					console.log("error ws updatePerfil", err);
					let msgError = "Se ha producido un error guardando los datos";

					observer.error(msgError);
				}
			);

			return {unsubscribe() {}};
		});
	}
}
